import MultiSelect from "./MultiSelect";
import { forwardRef, useImperativeHandle, useRef } from "react";

const MultiSelectRecord = (
  {
    field,
    recordID,
    value,
    mode,
    disabled,
    onUpdate,
    submitting,
    error,
    modifyTrigger,
    table,
  },
  ref
) => {
  const inputRef = useRef();
  const onChange = (newVals) => {
    onUpdate({
      field,
      recordID,
      payload: { [field.APIName]: newVals },
    });
  };

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current.focus();
    },
  }));

  return (
    <div className={`${table && "pr-2"}`}>
      <MultiSelect
        ref={inputRef}
        field={field}
        value={value}
        onChange={onChange}
        mode={mode}
        disabled={disabled}
        inputDisplayMode="subtle"
        modifyTrigger={modifyTrigger}
        tooltipTrigger={table ? "none" : "hover"}
        table={table}
      />
    </div>
  );
};

export default forwardRef(MultiSelectRecord);
